import { jsx as _jsx } from "react/jsx-runtime";
import * as React from "react";
import { any, fromJSX, stateful } from "widgets-for-react";
import { CarouselBlockLayout } from "./CarouselBlock.layout";
//todo: cleanup CarouselBlockState to only contain a list of images.
export const CarouselBlockWidget = (props)=>{
    return stateful()((s0)=>any({
            key: 'CarouselBlockWidget'
        })([
            // Render Layout
            fromJSX((setState)=>{
                return /*#__PURE__*/ _jsx(CarouselBlockLayout, {
                    ...props,
                    ...s0,
                    setMobile: (mobile)=>setState((s0)=>({
                                ...s0,
                                mobile: mobile
                            }))
                }, "CarouselBlockLayout");
            })
        ]).map((a)=>a(s0)))({
        mobile: window.innerWidth < 1024
    }).run((s0)=>s0);
};
